export const AppRoutes = {
  mainRoute: {
    main: 'landing-page',
    getDefault(): string {
      return `${AppRoutes.rateQuote.main}`;
    },
  },
  whatIf: { main: 'what-if' },
  rateQuote: {
    main: 'rate-quote',
    add: {
      main: 'add',
      generic: 'generic',
      customerSpecific: 'customer-specific',
    },
    viewQuote: { main: 'view-quote' },
    detailQuote: { main: 'detail-quote' },
  },
  ratingAnalysis: { main: 'rating-analysis' },
  manualRating: {
    main: 'manual-rating',
    manualRatePro: { main: 'manual-rate-pro' },
    manualRatingAuditor: 'auditor',
   },
  mrra: { 
    main: 'mrra',
    add: 'add'
   },
  dataEntryPage: { main: 'data-entry-page' },
  errorPages: {
    main: 'fail',
    notAuthorizedPage: 'not-authorized',
  },
};
